<template>
  <section class="bg-white py-20">
    <div class="container mx-auto px-4">
      <div class="flex flex-col items-center text-center" v-scroll-reveal="{ delay: 0.1 }">
        <p class="text-sm uppercase tracking-[0.6em] text-amber-500">Gallery</p>
        <h2 class="mt-4 text-4xl font-bold text-gray-900 lg:text-5xl">
          Moments from our Umrah Journeys
        </h2>
        <p class="mt-4 max-w-3xl text-gray-600">
          A glimpse into the spiritual experiences, serene mosques, and enriching excursions we curate for every pilgrim.
        </p>
      </div>

      <div class="mt-12 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        <figure
          v-for="(item, index) in gallery"
          :key="item.title"
          class="group relative overflow-hidden rounded-[32px]"
          v-scroll-reveal="{ delay: index * 0.1 }"
        >
          <img :src="item.image" :alt="item.title" class="h-72 w-full object-cover transition duration-500 group-hover:scale-105" />
          <figcaption class="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black/70 via-black/20 to-transparent p-6 text-white">
            <p class="text-xs uppercase tracking-[0.4em] text-amber-200">{{ item.category }}</p>
            <h3 class="text-2xl font-semibold">{{ item.title }}</h3>
            <p class="text-sm text-white/80">{{ item.description }}</p>
          </figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
import gallery1 from '../../assets/images/gallery-1.jpg'
import gallery3 from '../../assets/images/gallery-3.jpg'
import madinaDuskGate from '../../assets/images/madina/madina-dusk-gate.jpg'
import madinaNightCourtyard from '../../assets/images/madina/madina-night-courtyard.png'
import madinaAerialDusk from '../../assets/images/madina/madina-aerial-dusk.jpg'
import madinaDomeDusk from '../../assets/images/madina/madina-dome-dusk.jpg'
import { listItems } from '../../services/dataStore'

export default {
  name: 'GallerySection',
  async mounted() {
    this.gallery = await listItems('gallery', this.gallery)
  },
  data() {
    return {
      gallery: [
        {
          title: 'The Sacred Kaaba at Masjid al-Haram',
          category: 'Makkah',
          description: 'Pilgrims performing Tawaf around the Kaaba in the Grand Mosque.',
          image: gallery1
        },
        {
          title: 'Masjid an-Nabawi at Dusk',
          category: 'Madina',
          description: 'Pilgrims gathered at the gates of the Prophet\'s Mosque as evening lights come on.',
          image: madinaDuskGate
        },
        {
          title: 'Luxury Kaaba View Suite',
          category: 'Hospitality',
          description: 'Premium accommodations with panoramic view of the Holy Kaaba.',
          image: gallery3
        },
        {
          title: 'Masjid an-Nabawi Courtyard at Night',
          category: 'Madina',
          description: 'Pilgrims praying in the illuminated courtyard beneath the Green Dome.',
          image: madinaNightCourtyard
        },
        {
          title: 'Aerial View of the Prophet\'s Mosque',
          category: 'Madina',
          description: 'A sweeping dusk view of Masjid an-Nabawi and the surrounding city.',
          image: madinaAerialDusk
        },
        {
          title: 'Masjid an-Nabawi at Golden Hour',
          category: 'Madina',
          description: 'The Prophet\'s Mosque bathed in warm evening light, a moment of serenity.',
          image: madinaDomeDusk
        }
      ]
    }
  }
}
</script>

